import { Tabs } from "antd";
import { createContext, useContext, useEffect, useState, type PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";

type WorkspaceMode = "entry" | "data";
const WorkspaceContext = createContext<{
  mode: WorkspaceMode;
  setMode: (mode: WorkspaceMode) => void;
} | null>(null);
export const useOperationsWorkspace = () => useContext(WorkspaceContext);

export function OperationsWorkspaceTabs({ className = "" }: { className?: string }) {
  const workspace = useOperationsWorkspace();
  if (!workspace) return null;

  return (
    <Tabs
      className={`operations-entry-data-tabs ${className}`.trim()}
      type="card"
      activeKey={workspace.mode}
      onChange={(key) => workspace.setMode(key as WorkspaceMode)}
      items={[{ key: "entry", label: "Entry" }, { key: "data", label: "Data" }]}
    />
  );
}

export function OperationsTransactionWorkspace({
  children,
  tabsInHeader = false,
}: PropsWithChildren<{ tabsInHeader?: boolean }>) {
  const [mode, setMode] = useState<WorkspaceMode>("entry");
  const { pathname } = useLocation();

  // A transaction page must always open on its entry form. The workspace can be
  // reconciled across sibling routes, so explicitly discard the previous page's tab.
  useEffect(() => setMode("entry"), [pathname]);
  return <WorkspaceContext.Provider value={{ mode, setMode }}>
    {!tabsInHeader && <OperationsWorkspaceTabs />}
    <div className={`operations-workspace operations-workspace-${mode}`}>{children}</div>
  </WorkspaceContext.Provider>;
}
